<template>
  <div id="app">
    <div v-if="close" class="close-layer"></div>
    <div class="bg"></div>
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
import Ripple from 'vue-ripple-directive'

Ripple.color = 'rgba(229, 238, 245, 0.7)'
Ripple.zIndex = 1000
Vue.directive('ripple', Ripple)

export default {
  name: 'app',
  components: {
  },
  data: function()  { return {
    close: false
  }},
  methods: {

  }
}
</script>

<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
body {
  background-color: black
}
.close-layer {
  background-color:black
}
.bg {
  background-image: url('/static/img/screen2.jpg')
  background-position: center
  background-size: cover
  position:fixed
  top:0
  left:0
  height:100%
  width:100%
  z-index:-1
  opacity: 0.5
}

.relative-position {
  position:relative
}
.absolute-position: {
  position: absolute
}
.flex-center-both {
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
}
.nomargin {
  margin:0!important
}
.nopadding {
  padding:0!important
}
.full-height {
  height:100%
}
.full-width {
  width:100%
}
.ma-xs {
  margin: 5px
}
.ma-sm {
  margin: 10px
}
.ma-md {
  margin: 15px
}
.ma-lg {
  margin: 20px
}
.ma-xl {
  margin: 25px
}
.mt-xs {
  margin-top: 5px
}
.mt-sm {
  margin-top: 10px
}
.mt-md {
  margin-top: 15px
}
.mt-lg {
  margin-top: 20px
}
.mt-xl {
  margin-top: 25px
}
.mb-xs {
  margin-bottom: 5px
}
.mb-sm {
  margin-bottom: 10px
}
.mb-md {
  margin-bottom: 15px
}
.mb-lg {
  margin-bottom: 20px
}
.mb-xl {
  margin-bottom: 25px
}
.ml-xs {
  margin-left: 5px
}
.ml-sm {
  margin-left: 10px
}
.ml-md {
  margin-left: 15px
}
.ml-lg {
  margin-left: 20px
}
.ml-xl {
  margin-left: 25px
}
.mr-xs {
  margin-right: 5px
}
.mr-sm {
  margin-right: 10px
}
.mr-md {
  margin-right: 15px
}
.mr-lg {
  margin-right: 20px
}
.mr-xl {
  margin-right: 25px
}
.pa-xs {
  padding: 5px
}
.pa-sm {
  padding: 10px
}
.pa-md {
  padding: 15px
}
.pa-lg {
  padding: 20px
}
.pa-xl {
  padding: 25px
}
.pt-xs {
  padding-top: 5px
}
.pt-sm {
  padding-top: 10px
}
.pt-md {
  padding-top: 15px
}
.pt-lg {
  padding-top: 20px
}
.pt-xl {
  padding-top: 25px
}
.pb-xs {
  padding-bottom: 5px
}
.pb-sm {
  padding-bottom: 10px
}
.pb-md {
  padding-bottom: 15px
}
.pb-lg {
  padding-bottom: 20px
}
.pb-xl {
  padding-bottom: 25px
}
.pl-xs {
  padding-left: 5px
}
.pl-sm {
  padding-left: 10px
}
.pl-md {
  padding-left: 15px
}
.pl-lg {
  padding-left: 20px
}
.pl-xl {
  padding-left: 25px
}
.pr-xs {
  padding-right: 5px
}
.pr-sm {
  padding-right: 10px
}
.pr-md {
  padding-right: 15px
}
.pr-lg {
  padding-right: 20px
}
.pr-xl {
  padding-right: 25px
}
.col-center {
  align-self:center
}
.text-center {
  text-align:center
}
.text-left {
  text-align:left
}
.text-right {
  text-align:right
}
</style>
